import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {LocalStorageService} from '@core/services/local-storage';
import {BaseAuthenticationService} from '@core/abstract/authentication.abtract';
import {UrlService} from '@core/services/urlService';
import {isPlatformBrowser} from "@angular/common";


@Injectable({
  providedIn: 'root'
})
export class SignedInGuard implements CanActivate {

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private baseAuthenticationService: BaseAuthenticationService,
    private urlService: UrlService,
    @Inject(PLATFORM_ID) private platformId: object) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!isPlatformBrowser(this.platformId))
      return false;


    if (this.localStorageService.isLoggedIn())
      return true;

    this.baseAuthenticationService.userSignedIn.next(null);
    // Store the attempted URL for redirecting
    this.urlService.redirectUrl = state.url;
    this.router.navigate(['/authentication/signin']).then();
    return false;
  }

}
